'use strict';

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.onRouteUpdate = function () {
  // Don't track while developing.
  if (process.env.NODE_ENV === 'production' && (typeof _gauges === 'undefined' ? 'undefined' : (0, _typeof3.default)(_gauges)) === 'object') {
    _gauges.push(['track']);
  }
};